import {
  mapActions,
  mapState
} from 'vuex'
import Vue from 'vue'
import {
  AID,
  env,
  login,
  tenvideo,
  url,
  util
} from '@tencent/vft-common'
import {
  tenvideoService
} from '@tencent/vft-union-fetch'
import {
  removeHttp
} from '../util/helper'

Vue.mixin({
  computed: {
    ...mapState({
      rootUserInfo: 'userInfo',
      rootPayVip: 'payVip',
      rootIsLogin: 'isLogin'
    })
  },
  filters: {
    removeHttp
  },
  methods: {
    ...mapActions([
      'getUserInfo',
      'getPayVip',
      'checkLogin'
    ]),
    _openLogin(jumpUrl) {
      this.$openLogin({
        title: '登录态已过期，请重新登录',
        jumpUrl: jumpUrl || location.href
      })
    },
    _switchLogin() {
      this.$openLogin({
        title: '选择你要切换的帐号类型'
      })
    },
    strictLoginCall(cb, jumpUrl) {
      if (typeof cb === 'function') {
        login.isStrictLogin((isLogin) => {
          if (isLogin) {
            cb()
          } else {
            this._openLogin(jumpUrl)
          }
        })
      }
    },
    async rootOpenVip(actId) {
      let ptag = util.getUrlParam('ptag') || util.getUrlParam('PTAG') || util.getUrlParam('adtag') || util.getUrlParam('ADTAG') || ''
      const sandbox = util.getUrlParam('sandbox') ? 1 : ''
      const oAidStr = util.getUrlParam('aid')
      const aid = new AID(oAidStr)
      aid.set(13, actId)
      let aidStr = aid.toString()

      if (env.isIpad && env.isApp) {
        tenvideoService.tenvideoCall('PurchaseStatus')
        tenvideoService.tenvideoOn('PurchaseStatusCallback', (res) => {
          if (res.result.state === 'PurchaseSuccess') {
            window.location.reload()
          }
        })

        let absUrl = url.buildUrl('https://film.qq.com/ipad/upay/index.html', {
          lp: 1,
          sandbox,
          hlwactId: actId,
          dsp: 1,
          ru: window.location.href,
          ptag,
          aid: aidStr
        }, true)

        absUrl = 'txvideo://v.qq.com/PopHollywoodH5Activity?url=' + encodeURIComponent(absUrl)
        tenvideoService.tenvideoCall('openView', {
          url: absUrl
        })
        return
      }

      const h5Url = url.buildUrl('https://film.qq.com/weixin/upay.html', {
        lp: 1,
        hlwactId: actId,
        sandbox,
        ru: window.location.href,
        ptag,
        aid: aidStr
      }, true)
      this.rootOpenUrl(h5Url)
    },

    rootOpenUrl(url) {
      const sandbox = util.getUrlParam('sandbox') ? 1 : ''

      url = removeHttp(url)
      let ptag = util.getUrlParam('ptag') || util.getUrlParam('ptag', url) || ''
      url = util.delQueStr(url, 'ptag')
      url = util.setUrlParam('ptag', ptag, url)
      let ru = util.getUrlParam('ru', url)
      if (ru) {
        ru = decodeURIComponent(ru)
        ru = util.setUrlParam('ptag', ptag, ru)
        ru = encodeURIComponent(ru)
        url = util.setUrlParam('ru', ru, url)
      }
      url = util.setUrlParam('sandbox', sandbox, url)

      if (tenvideo.isAllTenvideo() && !env.isIpad) {
        tenvideo.openUrl(url)
      } else {
        window.location.href = url
      }
    }
  }
})
